export default {
  title: 'Oops. Pagina nu a fost găsită!',
  subtitle: 'Ai ajuns la marginea universului Sportya observabil.',
  goHome: 'Hai acasă',
  contact: `
    Și spune-ne cum ai ajuns aici, astfel încât să putem construi o lume mai bună (și un website mai bun) - <1>contact@sportya.net</1>. \nMultumim, prietene!`,
};
